import { ReactNode } from 'react';
import { Marks } from '@ametista-ai/editor/constants';
import { Button } from '@mantine/core';
import { useToggleEditorMark } from './useToggleEditorMark';

export function ToggleMarkButton({
  mark,
  label,
  active,
}: {
  mark: Marks;
  label: ReactNode;
  active?: boolean;
}) {
  const onClick = useToggleEditorMark(mark);

  return (
    <Button size="xs" onClick={onClick} variant={active ? 'filled' : 'default'}>
      {label}
    </Button>
  );
}
